/**
 * Decode JWT token payload (without signature verification)
 * @param {string} token - JWT token
 * @returns {object} Decoded payload
 */
export function decodeJWT(token) {
  try {
    if (!token) throw new Error('Invalid JWT')

    // JWT has 3 parts separated by dots: header.payload.signature
    const parts = token.split('.')
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format')
    }

    // Decode the payload (second part)
    const payload = parts[1]

    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - (payload.length % 4)) % 4)

    // Decode base64 and parse JSON
    // const decodedPayload = JSON.parse(atob(paddedPayload))
    const utf8Decoder = new TextDecoder()
    const decodedPayload = JSON.parse(utf8Decoder.decode(base64ToBytes(paddedPayload)))
    return decodedPayload
  } catch (error) {
    console.log('Error decoding JWT:', error)
  }
}

function base64ToBytes(base64) {
  const binString = atob(base64)
  return Uint8Array.from(binString, (char) => char.charCodeAt(0))
}
